import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ed9c8502&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ed9c8502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9c8502",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed9c8502')) {
      api.createRecord('ed9c8502', component.options)
    } else {
      api.reload('ed9c8502', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ed9c8502&scoped=true&", function () {
      api.rerender('ed9c8502', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IzYD95TKRnpX/JS/comp/PopupBox.vue"
export default component.exports